<template>
<div style="height:100%">
    <div id="cesiumContainer"></div>
    <div id="loadingOverlay"><h1>Loading........</h1></div>
</div>
</template>

<script>
    import * as Cesium from "cesium/Cesium";
    import widget from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: "GoogleImg",
        data() {
            return {
                vw: null,
                date: Date.now()
            };
        },
        mounted() {
             var loa=document.getElementById('loadingOverlay');
       setTimeout(()=>{
           loa.style.display="none";
       },4000);
            this.init();
        },
        methods: {
            init() {
                let viewer = util.getViewer("cesiumContainer", {

                    imageryProvider: new Cesium.UrlTemplateImageryProvider({
                        url:'http://mt2.google.cn/vt/lyrs=m@167000000&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}&s=Galil',
                        tilingScheme:new Cesium.WebMercatorTilingScheme(),
                        minimumLevel:1,
                        maximumLevel:20
                    }),
                    baseLayerPicker: false
                });
                this.viewer = viewer;

                let  cf = new Cesium.Cartesian3(-4107046.6468334734, 15755722.58519879, 12073099.956117895)  ;

                this.viewer.camera.setView({
                    destination :cf,
                    orientation : {
                        heading : 6.21390483292924,
                        pitch : -1.5664340610879344,
                        roll : 0.0
                    }
                });
            },

        }
    };
</script>

<style lang='less' scoped>
    #cesiumContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }

</style>
